export enum CustomerType {
	NotSet = 0,
	LimitedCompany = 1,
	Partnership = 2,
	PrivateIndividual = 3,
	SoleTrader = 4,
}

export enum DataGridColumnType {
	NotSet = 0,
	Default = 1,
	Boolean = 2,
	NegativeBoolean = 3,
	Financial = 4,
	Formatted = 5,
	Html = 6,
	HyperLink = 7,
	Icon = 8,
	MailTo = 9,
	Tooltip = 10,
	ConditionalClass = 11,
	Badge = 12,
}

export enum DataSourceMode {
	NotSet = 0,
	Client = 1,
	Server = 2,
}

export enum EditBusinessPartnerType {
	Customer = 0,
	Partner = 1,
	Proprietor = 2,
}

export enum FilterType {
	NotSet = 0,
	TextBox = 1,
	DropDown = 2,
	TierSelector = 3,
	Date = 4,
}

export enum GlobalSearchFilterType {
	Proposal = 0,
	RACA = 1,
	Drawdown = 2,
	FSA = 3,
	Customer = 4,
	Policy = 5,
	WIP = 6,
}

export enum ListSortDirection {
	Ascending = 0,
	Descending = 1,
}

export enum LoanType {
	NotSet = 0,
	Consumer = 1,
	Commercial = 2,
}

export enum MessageType {
	Info = 0,
	Success = 1,
	Warning = 2,
	Error = 3,
}

export enum MTAType {
	Positive = 0,
	Negative = 1,
}

export enum NcqLogLevel {
	Trace = 0,
	Debug = 1,
	Information = 2,
	Warning = 3,
	Error = 4,
	Critical = 5,
	None = 6,
}

export enum NewBusinessPoliciesStage {
	NotSet = 0,
	PolicyDetails = 1,
	FinancialDetails = 2,
	Results = 3,
}

export enum NewBusinessWizardStep {
	NotSet = 0,
	Search = 1,
	CustomerType = 2,
	CustomerInformation = 3,
	Parties = 4,
	Policies = 5,
	BankDetails = 6,
	Summary = 7,
}

export enum TierLevel {
	NotSet = 0,
	Broker = 1,
	Branch = 2,
	Group = 3,
}

export enum TimeoutDuration {
	NotSet = 0,
	Fast = 1,
	Standard = 2,
	Slow = 3,
}

export enum WipType {
	NewBusiness = 0,
	Renewal = 1,
	Drawdown = 2,
	MTA = 3,
}

